import type { OpenerGroup } from '../api/useGroups';

/**
 * Canonical opener-group ordering, shared by the EntryPage group selector
 * and the BucketPage rail so the two lists can never disagree: `sortOrder`
 * ascending with MISSING sortOrder sorting LAST, ties broken A→Z by name.
 * Returns a new array; accepts undefined for hook-data convenience.
 */
export function sortGroups<T extends Pick<OpenerGroup, 'name' | 'sortOrder'>>(
  groups: T[] | undefined
): T[] {
  return [...(groups ?? [])].sort((a, b) => {
    const sa = a.sortOrder ?? Number.MAX_SAFE_INTEGER;
    const sb = b.sortOrder ?? Number.MAX_SAFE_INTEGER;
    if (sa !== sb) return sa - sb;
    return a.name.localeCompare(b.name);
  });
}
